// THE WORKSPACE APPS VIEW (/apps) — docs/APP_SPLIT.md §5.2,
// WS-STUDIO-SPLIT-WORKSPACE-APPS-FROM-SITES. Nika 2026-10-19: "workspace apps
// are pure adons on workspace and websites made on it are deployed and
// published". The Apps hub has two views (CanvasViewNav VIEW_NAV): this one
// holds the add-ons of the workspace — installed, built by the team, offered
// by the App Store. Websites live on the /studio board, never here.
//
// Rows come from `appsHubModel` (functions/appsHub.js): each row carries every
// key it reads and an `app-…` key, so no row falls back to the root state and
// no data key names an HTML tag.

// One app: its glyph (the launcher's plate), its name (the store's resolver —
// one app, one name everywhere), where it comes from, its channel, and the
// actions that lead to its OWN flow (open in the workspace, change in /add-app,
// manage in the App Store). The card itself is not a button.
export const AppsHubCard = {
  tag: 'div',
  flow: 'x',
  // The actions wrap under the name when the card is narrow — the name keeps
  // its words whole ("Excalidr aw" broke mid-word on dev, 2026-10-21).
  flexWrap: 'wrap',
  align: 'center flex-start',
  gap: 'A',
  padding: 'A',
  minWidth: '0',
  round: 'radiusCard',
  // A surface, never a stroke (the brand law: no painted border on anything
  // but a form field).
  background: 'overlay',
  dataAppId: (el, s) => s.id,

  // The launcher's plate, on this page's surface: its hairline gives way to a
  // fill for the same reason.
  AppGlyphPlate: { borderWidth: '0', background: 'overlayStrong' },

  AhText: {
    flow: 'y',
    gap: 'Y',
    minWidth: 'F',
    flex: '1 1 0',
    AhName: {
      tag: 'span',
      fontSize: 'A',
      fontWeight: '700',
      color: 'title',
      overflowWrap: 'break-word',
      text: (el, s) => el.call('storeItemText', { key: s.appKey, name: s.title }, 'name')
    },
    AhChips: {
      flow: 'x',
      flexWrap: 'wrap',
      gap: 'Y',
      AppStatusChip_source: {
        label: (el, s) =>
          s.source === 'ai'
            ? 'workspace.appsHub.source.ai'
            : s.source === 'custom'
              ? 'workspace.appsHub.source.custom'
              : 'workspace.appsHub.source.store'
      },
      AppStatusChip_channel: {
        hide: (el, s) => !s.installed,
        status: (el, s) => (s.channel === 'development' ? 'warning' : null),
        label: (el, s) =>
          s.channel === 'development'
            ? 'workspace.appsHub.channel.development'
            : 'workspace.appsHub.channel.production'
      },
      AppStatusChip_state: {
        hide: (el, s) => !!s.installed,
        label: 'workspace.appsHub.state.notInstalled'
      }
    }
  },

  AhActions: {
    flow: 'x',
    flexWrap: 'wrap',
    gap: 'Y',
    flexShrink: '0',
    AhOpen: {
      extends: 'AppCapsuleBtnPrimary',
      compact: true,
      hide: (el, s) => !s.installed || !s.route,
      text: '{{ workspace.appsHub.action.open | polyglot }}',
      onClick: (e, el, s) => {
        e.stopPropagation()
        el.call('appsHubOpen', s.parse ? s.parse() : s)
      }
    },
    AhEdit: {
      extends: 'AppCapsuleBtnGhost',
      compact: true,
      hide: (el, s) => s.source !== 'ai' || !s.projectId,
      text: '{{ workspace.appsHub.action.edit | polyglot }}',
      onClick: (e, el, s) => {
        e.stopPropagation()
        el.call('appsHubEdit', s.parse ? s.parse() : s)
      }
    },
    AhManage: {
      extends: 'AppCapsuleBtnGhost',
      compact: true,
      hide: (el, s) => s.source === 'ai' || !s.owner || !s.appKey,
      text: '{{ workspace.appsHub.action.manage | polyglot }}',
      onClick: (e, el, s) => {
        e.stopPropagation()
        el.call('appsHubManage', s.parse ? s.parse() : s)
      }
    }
  }
}
